import * as THREE from 'three';
import { Params } from '../data/Params';

//文字中に描かれるドット

export class MojiDot{

    x:number = 0;
    y:number = 0;
    z:number = 0;
    v:THREE.Vector3;
    index       :number = 0;
    //spd:number = 0.001;
    scale       :number = 1;
    velocity    :number = 0;
    enabled     :boolean = false;
    ratio       :number=0;
    count       :number=0;
    tgtIndex    :number[]=[];

    constructor(x:number,y:number,z:number,s:number,r:number){

        this.x = x;
        this.y = y;
        this.z = z;
        this.v = new THREE.Vector3(this.x,this.y,this.z);
        this.scale = s;
        this.ratio = r%1;

    }

    update(){

        this.scale+=(1-this.scale)/10;

        this.velocity*=0.96;

        this.ratio+=Params.dot_speed;//this.spd;
        this.ratio+=this.velocity;

        if(this.ratio>=1.0){
            this.ratio=this.ratio-1.0;
        }

    }

}